module.exports = __webpack_public_path__ + "img/mnone@2x.644603d8.png";